import { computed, ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-140f3405"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tier-default-price"
};
const _hoisted_2 = {
  class: "tier-tip"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "T1 已被锁定为系统的全局兜底层级。平台未来新增的国家，以及未匹配到有效默认价格的国家，都将自动应用 T1 的价格。", -1));
const _hoisted_4 = {
  class: "tier-tag"
};
import SvgIcon from '@/components/SvgIcon.vue';
import { PlusCircleOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { getLadderPrice } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'TierDefaultPrice',
  props: {
    prodChnl: {
      type: String,
      default: ''
    },
    prodType: {
      type: String,
      default: ''
    },
    dbtId: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 苹果国家下拉选项（复用详情页 defaultCountry）
    countryOptions: {
      type: Array,
      default: () => []
    },
    // 谷歌默认币种（右侧金额单位）
    prodPriceCurrency: {
      type: String,
      default: 'USD'
    }
  },
  emits: ['change'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    // 层级默认价变更 → 把被编辑的层级码通知父级，由父级判断是否重算本地价（接口①）：
    // T1 是全局兜底层级，改动必重算全表；T2–T5 基准价仅当该层级已分配国家时才重算，
    // 未分配国家的层级改价不调接口（无国家可算），新价在「分配国家」或保存时才生效
    const onTierEdited = tier => {
      emit('change', tier.tierCode);
    };
    const MAX_TIER = 5;
    const isApple = computed(() => props.prodChnl === 'apple');
    const list = ref([]);
    const canAddTier = computed(() => list.value.length < MAX_TIER);
    const buildTier = tierCode => ({
      tierCode,
      regionCode: '',
      prodPriceCurrency: '',
      prodPrice: '',
      priceTier: '',
      priceId: '',
      ladderOptions: [],
      loading: false,
      usd: '',
      localPrice: ''
    });
    // 初始默认仅展示 T1，T2–T5 由用户手动添加
    const init = data => {
      if (data && data.length) {
        list.value = data.map(item => ({
          ...buildTier(item.tierCode),
          ...item
        }));
      } else {
        list.value = [buildTier('T1')];
      }
    };
    const reset = () => {
      init();
    };
    const addTier = () => {
      if (!canAddTier.value) return;
      list.value.push(buildTier('T' + (list.value.length + 1)));
    };
    // 仅允许从最大层级往上删除，T1 永久豁免不可删
    // 携带被删层级码通知父级：该层级有国家归属时才重算（让其国家回落 T1）
    const removeLastTier = () => {
      if (list.value.length <= 1) return;
      const removed = list.value.pop();
      emit('change', removed === null || removed === void 0 ? void 0 : removed.tierCode);
    };
    const filterCountry = (input, option) => {
      return (option.regionName || '').toLowerCase().includes(input.toLowerCase());
    };
    const getNode = node => node.parentNode;
    // 苹果：选择国家后拉取该国档位价格列表
    const onCountryChange = async (tier, regionCode) => {
      tier.prodPrice = '';
      tier.priceTier = '';
      tier.priceId = '';
      tier.ladderOptions = [];
      if (!regionCode) return;
      tier.loading = true;
      try {
        const res = await getLadderPrice({
          dbtId: props.dbtId,
          regionCode,
          prodType: props.prodType
        });
        tier.ladderOptions = res.code === '0' ? res.data : [];
      } finally {
        tier.loading = false;
      }
      const country = props.countryOptions.find(c => c.regionCode === regionCode);
      tier.prodPriceCurrency = (country === null || country === void 0 ? void 0 : country.prodPriceCurrency) || '';
    };
    // 苹果：选中档位后回填档位标识
    // 带上层级码通知父级：T1 必重算；T2–T5 仅当该层有国家归属时才重算（空层级改价不刷新本地价表）
    const onTierPriceChange = tier => {
      const matched = (tier.ladderOptions || []).find(item => item.prodPrice === tier.prodPrice);
      if (matched) {
        tier.priceTier = matched.priceTier;
        tier.priceId = matched.priceId;
        tier.prodPriceCurrency = matched.prodPriceCurrency || tier.prodPriceCurrency;
      }
      emit('change', tier.tierCode);
    };
    // 校验：T1 必填；其余层级填了才计入，已填的需完整
    const validate = () => {
      for (let i = 0; i < list.value.length; i++) {
        const tier = list.value[i];
        const filled = isApple.value ? !!tier.prodPrice : !!tier.usd || !!tier.localPrice;
        if (tier.tierCode === 'T1' && !filled) {
          return false;
        }
      }
      return true;
    };
    // 有效层级：填了价格的层级（T1 始终计入）
    const validTiers = () => list.value.filter(tier => {
      if (tier.tierCode === 'T1') return true;
      return isApple.value ? !!tier.prodPrice : !!tier.usd || !!tier.localPrice;
    });
    // 编辑回显：批量加载各层级基准国的阶梯价下拉（仅苹果），让价格下拉可展示选项并可切换
    const loadAllLadderOptions = async () => {
      if (!isApple.value) return;
      await Promise.all(list.value.map(async tier => {
        if (!tier.regionCode) return;
        tier.loading = true;
        try {
          const res = await getLadderPrice({
            dbtId: props.dbtId,
            regionCode: tier.regionCode,
            prodType: props.prodType
          });
          tier.ladderOptions = res.code === '0' ? res.data : [];
        } finally {
          tier.loading = false;
        }
      }));
    };
    onMounted(() => {
      if (!list.value.length) init();
    });
    expose({
      list,
      init,
      reset,
      validate,
      validTiers,
      loadAllLadderOptions
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input_number = _resolveComponent("a-input-number");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ExclamationCircleOutlined), {
        class: "tier-tip-icon"
      }), _hoisted_3]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (tier, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: tier.tierCode,
          class: "tier-row"
        }, [_createElementVNode("span", _hoisted_4, _toDisplayString(tier.tierCode), 1), _unref(isApple) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_a_select, {
          class: "tier-country",
          value: tier.regionCode,
          "onUpdate:value": $event => tier.regionCode = $event,
          "show-search": "",
          placeholder: "请选择国家",
          disabled: __props.disabled,
          options: __props.countryOptions,
          "field-names": {
            label: 'regionName',
            value: 'regionCode'
          },
          "filter-option": filterCountry,
          getPopupContainer: getNode,
          onChange: val => onCountryChange(tier, val)
        }, null, 8, ["value", "onUpdate:value", "disabled", "options", "onChange"]), _createVNode(_component_a_select, {
          class: "tier-price",
          value: tier.prodPrice,
          "onUpdate:value": $event => tier.prodPrice = $event,
          "show-search": "",
          placeholder: "请选择价格",
          disabled: __props.disabled,
          loading: tier.loading,
          options: tier.ladderOptions,
          "field-names": {
            label: 'prodPrice',
            value: 'prodPrice'
          },
          getPopupContainer: getNode,
          onChange: () => onTierPriceChange(tier)
        }, null, 8, ["value", "onUpdate:value", "disabled", "loading", "options", "onChange"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_a_input_number, {
          class: "tier-amount",
          value: tier.usd,
          "onUpdate:value": $event => tier.usd = $event,
          "addon-after": "USD",
          step: 0.01,
          controls: false,
          precision: 2,
          "string-mode": "",
          disabled: __props.disabled,
          placeholder: "请输入",
          onBlur: $event => onTierEdited(tier)
        }, null, 8, ["value", "onUpdate:value", "step", "disabled", "onBlur"]), __props.prodPriceCurrency !== 'USD' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(SvgIcon, {
          "icon-class": "swap",
          class: "swap-icon"
        }), _createVNode(_component_a_input_number, {
          class: "tier-amount",
          value: tier.localPrice,
          "onUpdate:value": $event => tier.localPrice = $event,
          "addon-after": __props.prodPriceCurrency,
          step: 0.01,
          controls: false,
          precision: 2,
          "string-mode": "",
          disabled: __props.disabled,
          placeholder: "请输入",
          onBlur: $event => onTierEdited(tier)
        }, null, 8, ["value", "onUpdate:value", "addon-after", "step", "disabled", "onBlur"])], 64)) : _createCommentVNode("", true)], 64)), idx === 0 && !__props.disabled ? (_openBlock(), _createBlock(_unref(PlusCircleOutlined), {
          key: 2,
          class: _normalizeClass(["opt-icon add-icon", {
            disabled: !_unref(canAddTier)
          }]),
          onClick: addTier
        }, null, 8, ["class"])) : _createCommentVNode("", true), idx !== 0 && idx === list.value.length - 1 && !__props.disabled ? (_openBlock(), _createBlock(_unref(DeleteOutlined), {
          key: 3,
          class: "opt-icon del-icon",
          onClick: removeLastTier
        })) : _createCommentVNode("", true)]);
      }), 128))]);
    };
  }
});